export default "__VITE_ASSET__CLT3ql6v__"